import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/scan/$token")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/guard-tours/scan",
      search: { token: params.token },
    });
  },
});
